// hooks/useTeachers.js
import { useState, useEffect } from "react";
import { deleteApi, getApi, postApi, putApi } from "../../services/api";
import { useForm } from "antd/es/form/Form";
import { toast } from "react-toastify"; // Import toast

function useTeachers() {
	const [teachers, setTeachers] = useState([]);
	const [filteredTeachers, setFilteredTeachers] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [modalType, setModalType] = useState("");
	const [selectedTeacher, setSelectedTeacher] = useState(null);
	const [form] = useForm();
	// Fetch teacher data from the database
	useEffect(() => {
		const fetchTeachers = async () => {
			try {
				const response = await getApi(`/users`, { role: "teacher" });

				if (response && !response.error) {
					setTeachers(response); // Set fetched teachers
					setFilteredTeachers(response); // Update filtered teachers
				} else {
					console.error(
						`Error fetching teachers: ${response.message || "Unknown error"}`
					);
				}
			} catch (error) {
				console.error(`Error fetching teachers: ${error.message}`);
			}
		};

		fetchTeachers();
	}, []);

	// Update filtered teachers based on the search term
	useEffect(() => {
		if (searchTerm === "") {
			setFilteredTeachers(teachers);
		} else {
			setFilteredTeachers(
				teachers.filter((teacher) =>
					teacher.fullName
						.toLowerCase()
						.includes(searchTerm.toLowerCase())
				)
			);
		}
	}, [searchTerm, teachers]);

	const showModal = async (type, teacher) => {
		setModalType(type);
		setSelectedTeacher(teacher); // Update the selected teacher state with the fetched data

		if (type === "edit") {
			// Ensure that availableTimes are set for viewing
			form.setFieldsValue({
				...teacher,
			});
		} else {
			form.resetFields();
		}
		setIsModalVisible(true);

		setIsModalVisible(true); // Show the modal
	};

	const handleModalConfirm = async (values) => {
		try {
			let response;
			if (modalType === "edit") {
				response = await putApi(`/users/${selectedTeacher._id}`, {
					fullName: values.fullName,
					email: values.email,
					phoneNumber: values.phoneNumber,
				});
			} else if (modalType === "delete") {
				response = await deleteApi(`/users/${selectedTeacher._id}`);
			} else if (modalType === "add") {
				response = await postApi(`/users/registerTeacher`, {
					fullName: values.fullName,
					email: values.email,
					password: values.password,
					phone: values.phoneNumber,
				});
			}

			if (!response.error) {
				const updatedTeacher = response;
				if (modalType === "edit") {
					setTeachers((prev) =>
						prev.map((teacher) =>
							teacher.id === selectedTeacher._id
								? updatedTeacher
								: teacher
						)
					);
					setFilteredTeachers((prev) =>
						prev.map((teacher) =>
							teacher.id === selectedTeacher._id
								? updatedTeacher
								: teacher
						)
					);
					toast.success("Teacher details updated successfully!");
				} else if (modalType === "add") {
					setTeachers((prev) => [...prev, updatedTeacher]);
					setFilteredTeachers((prev) => [...prev, updatedTeacher]);
					toast.success("Teacher added successfully!");
				}
			} else {
				console.error("Error updating teacher:", response.message);
			}
		} catch (error) {
			console.error("Error updating teacher:", error.message);
		}

		setIsModalVisible(false);
	};

	const handleModalCancel = () => {
		setIsModalVisible(false);
	};

	return {
		teachers,
		filteredTeachers,
		searchTerm,
		setSearchTerm,
		isModalVisible,
		setIsModalVisible,
		modalType,
		setModalType,
		selectedTeacher,
		setSelectedTeacher,
		handleModalConfirm,
		handleModalCancel,
		showModal,
		form,
	};
}

export default useTeachers;
